<template>
  <div class="collection">
    <!------搜索模块---->
    <CollectionSearch
      ref="CollectionSearch"
      :currentSummary="currentSummary"
      @reset="reset"
      @searchHandle="searchHandle"
      @addFn="addFn"
      @createMoreWithhold="createMoreWithhold"
      @alipayConfig="alipayConfig"
      @addRecordHandle="addRecordHandle"
    />
    <QS-common-table
      class="mt16"
      :loading="oLoading.search"
      :pagination="m_paginationData"
      :data="receiptData"
      :columns="m_headData"
      @change="paginationChange"
    >
  </QS-common-table>
    <!------新建应收---->
    <CollectionAdd v-model="oShow.addReceivable" @searchHandle="searchHandle" />
    <!-- 新增变更计划 -->
    <CollectionAddChangePlan
      v-model="oShow.changePlan"
      :row="addChangePlanData"
      @searchHandle="searchHandle"
    />
    <!------新建收款单---->
    <dialogWrap v-model="oShow.addBill" title="新增收款单" :width="'824px'">
      <AddReceipt
        ref="addBill"
        v-if="oShow.addBill"
        :data="detailSource"
        :optionType="1"
        :type="1"
      ></AddReceipt>
      <template slot="footer">
        <el-button size="small" @click="cencelFn('bill')">取消</el-button>
        <el-button
          :loading="oLoading.addOrder"
          size="small"
          type="primary"
          @click="addBillSubmit"
          >确认新增</el-button
        >
      </template>
    </dialogWrap>

    <dialogWrap
      v-model="oShow.complete"
      title="提示"
      width="'560px'"
      custom-class="dialog-message"
    >
      <div v-html="completeDialogTitle"></div>
      <template slot="footer">
        <el-button size="small" @click="cencelFn('complete')">取消</el-button>
        <el-button
          :loading="oLoading.state"
          size="small"
          type="primary"
          @click="submitCompleteHandle"
          >确认</el-button
        >
      </template>
    </dialogWrap>
    <!-- 支付宝支付定时配置 -->
    <AlipayConfig
      v-model="oShow.alipayConfig"
      :alipayConfigData="alipayConfigData"
    ></AlipayConfig>
    <AlipayWithhold
      v-model="oShow.alipayWithhold"
      :receivableItem="receivableItem"
    ></AlipayWithhold>
    <!-- 未开启支付宝支付功能提示弹窗 -->
    <dialogWrap
      v-model="msgDialogVisible"
      :before-close="closeMsgDialogVisible"
      title="提示"
      :width="'524px'"
    >
      <div>
        {{ msgType == 20 ? '未开通网约钱包支付功能' : '未开通支付宝支付功能' }}
      </div>
      <template slot="footer">
        <el-button type="primary" size="small" @click="closeMsgDialogVisible"
          >确定</el-button
        >
      </template>
    </dialogWrap>
    <!-- 网约钱包支付2.0不展示该弹框，网约钱包支付1.0是否展示该弹框根据方法createMoreWithhold判断-->
    <CreateWithholdPlan ref="CreateWithholdPlan" @addSuccess="searchHandle" />
    <!-- 减免金额弹窗 -->
    <DeductionAmount
      :row="deductionAmountRow"
      v-model="showDialog"
      @searchHandle="searchHandle"
    />

    <!-- 12.26 线下批量还款弹窗 -->
    <BatchCollectionRecordAdd
      :visible.sync="batchCollectionRecordAddVisible"
      scenetype="receivable"
      @refresh="searchHandle"
    />
  </div>
</template>

<script>
// 接口
// eslint-disable-next-line import/no-cycle
import { checkConfigState } from '@/api/company'
import {
  addReceipt,
  closeCollectionCheck,
  getAlipayConfig,
  getReceivableByESList,
  getReceivableByESStatistic,
  getReceivableDetail,
  updateCollectionState,
} from '@/api/financeApi'
// 组件
import AddReceipt from '@/pages/finance/addReceipt'
import CollectionSearch from '@/pages/finance/collection/components/CollectionSearch.vue'
import BatchCollectionRecordAdd from './components/BatchCollectionRecordAdd/index.vue'
import DeductionAmount from './components/DeductionAmount.vue'

// 批量创建网约代扣
import CollectionAdd from '@/pages/finance/collection/components/CollectionAdd.vue'
import CreateWithholdPlan from '@/pages/finance/collection/components/CreateWithholdPlan.vue'
import AlipayConfig from '@/pages/finance/components/AlipayConfig.vue'
import AlipayWithhold from '@/pages/finance/components/AlipayWithhold.vue'
import CollectionAddChangePlan from '@/pages/finance/components/CollectionAddChangePlan.vue'
// import WalletConfig from '@/pages/finance/collection/components/WalletConfig.vue'

// 其他依赖
import listMixins from '@/pages/finance/collection/mixins/collectionList'
import { overdueUtils } from '@/pages/utils/overdue'
import { FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  mixins: [listMixins],
  name: 'collection',
  components: {
    CollectionAdd,
    AddReceipt,
    CollectionSearch,
    CollectionAddChangePlan,
    AlipayConfig,
    AlipayWithhold,
    CreateWithholdPlan,
    DeductionAmount,
    BatchCollectionRecordAdd,
  },
  data() {
    const { ifOfflineOverdueItem } = overdueUtils.call(this)
    return {
      batchCollectionRecordAddVisible: false,
      ifOfflineOverdueItem,
      deductionAmountRow: {}, // 减免金额选中数据
      showDialog: false, // 减免金额弹窗
      msgType: 20,
      msgDialogVisible: false,
      currentSummary: {},
      oLoading: {
        // eslint-disable-next-line vue/no-unused-properties
        fuzzySearch: false,
        search: false,
        // eslint-disable-next-line vue/no-unused-properties
        add: false,
        addOrder: false,
        state: false,
      },
      // eslint-disable-next-line vue/no-unused-properties
      collectionContentDict: selectOption.collectionContentDict,
      sourceOrderTypeDict: selectOption.sourceOrderTypeDict,
      // eslint-disable-next-line vue/no-unused-properties
      completionStatusDict: selectOption.completionStatusDict,
      // eslint-disable-next-line vue/no-unused-properties
      payMethodList: selectOption.payMethods,
      // 组件的添加新增付款单的表单
      addBillRef: null,
      // 新增应收组件ref
      // eslint-disable-next-line vue/no-unused-properties
      addReceivableRef: null,
      oShow: {
        // eslint-disable-next-line vue/no-unused-properties
        close: false,
        addBill: false,
        addReceivable: false,
        complete: false,
        changePlan: false,
        alipayConfig: false,
        alipayWithhold: false,
        // eslint-disable-next-line vue/no-unused-properties
        walletConfig: false,
      },
      completeId: '',
      completeDialogTitle: '',
      receiptData: [],
      detailSource: {},
      addChangePlanData: {}, // 新增变更计划数据
      alipayConfigData: {
        // 支付宝支付定时配置默认数据
        onState: 1,
        state: 1,
        withholdTime: '00-00-00',
        exeTime: '00-00-00',
      },
      // eslint-disable-next-line vue/no-unused-properties
      collectibleAmount: 0, // 支付宝支付最大可收金额
      receivableItem: {}, // 应收项
    }
  },
  mounted() {
    this.getReceivableList()
  },
  computed: {
    /* eslint-disable vue/no-unused-properties */
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  methods: {
    reset() {
      // 清空sessionStorage中缓存的查询参数
      sessionStorage.removeItem('finance_collection_search_params')
      this.m_paginationData.pageNum = 1
      this.searchHandle()
    },
    // 金额减免
    // eslint-disable-next-line vue/no-unused-properties
    deductionAmount(row) {
      this.showDialog = true
      this.deductionAmountRow = row
    },
    // 线下批量收款
    async addRecordHandle(type) {
      if (type !== 'offline') return
      // 弹窗
      this.batchCollectionRecordAddVisible = true
    },
    // 批量创建网约代扣
    async createMoreWithhold() {
      const { code, data } = await checkConfigState({
        type: 20,
      })
      if (code === 1 && !data) {
        this.msgDialogVisible = true
        this.msgType = 20
        return
      }
      this.$refs.CreateWithholdPlan.dialogVisible = true
    },
    // 关闭支付宝支付未开启提示弹框
    closeMsgDialogVisible() {
      this.msgDialogVisible = false
    },
    // eslint-disable-next-line vue/no-unused-properties
    bianGeng_button(scope) {
      return (
        scope.row.receivableState !== 1 &&
        Number(scope.row.receivableState) !== 2 &&
        // +scope.row.receivedAmount <= +scope.row.receivableAmount &&
        this.judgePermission('finance_receivable_changeReceivable')
      )
    },
    // 收款状态  0: '未完成',1: '已完成',2: '已关闭'
    // 首款状态为未完成并且已收金额+收款中金额=0 展示关闭按钮
    // eslint-disable-next-line vue/no-unused-properties
    close_button(scope) {
      return (
        scope.row.receivableState === 0 &&
        this.judgePermission('finance_receivable_state') &&
        Number(scope.row.receivedAmount) === 0 &&
        Number(scope.row.receivingAmount) === 0
      )
    },
    // eslint-disable-next-line vue/no-unused-properties
    moreOption(scope) {
      return (
        scope.row &&
        scope.row.content &&
        scope.row.content === 1 &&
        scope.row.payMethods &&
        scope.row.payMethods.includes(30) &&
        scope.row.receivableState === 0 &&
        this.curReceivablAmount(scope.row)
      )
    },
    // 新增变更计划
    // eslint-disable-next-line vue/no-unused-properties
    addChangePlan(row) {
      this.addChangePlanData = row
      this.oShow.changePlan = true
    },
    // 获取请求参数
    getSearchParamrs() {
      const searchData =
        this.$refs?.CollectionSearch?.searchData || {}
      let startDate = ''
      let endDate = ''
      let completeStartDate = ''
      let completeEndDate = ''
      if (searchData.times && searchData.times.length) {
        startDate = searchData.times[0]
        endDate = searchData.times[1]
      }
      if (searchData.completeTime && searchData.completeTime.length) {
        completeStartDate = searchData.completeTime[0]
        completeEndDate = searchData.completeTime[1]
      }
      const params = {
        ...searchData,
        startDate,
        endDate,
        completeStartDate,
        completeEndDate,
      }
      return params
    },

    // 获取应收列表 && 获取应收列表统计
    async getReceivableList() {
      this.saveSearchData()
      this.oLoading.search = true
      try {
        const { code, data } = await getReceivableByESList({
          ...this.getSearchParamrs(),
          pageNum: this.m_paginationData.pageNum,
          pageSize: this.m_paginationData.pageSize,
        })
        this.oLoading.search = false
        if (code === 1) {
          this.m_paginationData.total = data.totalNum
          this.receiptData = data.items
        }
      } catch (error) {
        this.oLoading.search = false
      }
      getReceivableByESStatistic({
        ...this.getSearchParamrs(),
        pageNum: this.m_paginationData.pageNum,
        pageSize: this.m_paginationData.pageSize,
      })
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.currentSummary = data
          }
        })
    },

    // 搜索事件
    searchHandle(toFirstPage = true) {
      this.m_paginationData.pageNum =
        (toFirstPage && 1) || this.m_paginationData.pageNum
      this.getReceivableList()
    },

    // 获取应收详情
    // eslint-disable-next-line vue/no-unused-properties
    async getReceivableDetail(id) {
      try {
        const { code, data } = await getReceivableDetail({ id })
        return new Promise((resolve, reject) => {
          if (code === 1) {
            // this.detailSource = { ...data }
            this.detailSource = {
              ...data,
              receivableAmount: this.numberWithCommas(data.receivableAmount), // 应收金额
              receivedAmount: this.numberWithCommas(data.receivedAmount), // 已收金额
            }
            Object.keys(this.detailSource).forEach((item) => {
              if (item === 'sourceOrderType') {
                this.detailSource[item] = this.sourceOrderTypeDict[
                  this.detailSource[item]
                ]
              }
              if (item === 'receivableState') {
                this.detailSource[item] =
                  selectOption.batchStateDict[this.detailSource[item]]
              }
            })
            resolve()
          } else {
            reject()
          }
        })
      } catch (error) {
        return new Promise((resolve, reject) => {
          reject()
        })
      }
    },

    // 查看详情弹窗
    // eslint-disable-next-line vue/no-unused-properties
    viewDetails(id) {
      this.$router.push({
        path: '/finance/collection/detail',
        query: { id },
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    linkReceipt(id) {
      this.$router.push({
        path: '/finance/receiptList',
        query: { id },
      })
    },

    // 线下收款
    // eslint-disable-next-line vue/no-unused-properties
    addBillDialog({ id, relReceivableState }) {
      // 对新滞纳金线下收款逻辑
      if (this.ifOfflineOverdueItem(relReceivableState)) {
        return
      }
      this.$router.push({
        path: '/finance/AddCollection',
        query: {
          paymentIds: id,
          approvalOrigin: 1,
        },
      })
    },

    // 取消按钮操作
    cencelFn(type) {
      if (type === 'bill') {
        if (this.addBillRef) {
          this.addBillRef.resetFields()
        }
        this.oShow.addBill = false
      }

      if (type === 'complete') {
        this.oShow.complete = false
      }
    },

    // 新建应收
    addFn() {
      this.oShow.addReceivable = true
    },

    // 新增收款单
    addBillSubmit() {
      // this.oShow.addBill = false
      this.$refs.addBill
        .formValidate()
        .then((data) => {
          this.oLoading.addOrder = true
          addReceipt(data)
            .then(({ code }) => {
              this.oLoading.addOrder = false
              if (code === 1) {
                this.$message.success('操作成功')
                this.getReceivableList()
                this.oShow.addBill = false
              }
            })
            .catch(() => {
              this.oLoading.addOrder = false
            })
        })
        .catch(() => null)
    },

    // 确认完成弹窗
    // eslint-disable-next-line vue/no-unused-properties
    async completeHandle(row) {
      const { id } = row
      const data = this.receiptData.filter((item) => {
        return item.id === id
      })[0]
      this.completeDialogTitle = `提前关闭应收单，将无法继续收款。<br>
      当前应收${data.receivableAmount}元，已收${
  data.receivedAmount
}元，是否放弃收取剩余金额${data.endMoney}元？`
      // 是租金时
      if (data.content === FEE_CODE_MAP.ZU_JIN) {
        const params = { id, receivableState: 2 }
        // 关闭应收状态前，先校验，获取提示信息
        const res = await closeCollectionCheck(params)
        // eslint-disable-next-line no-shadow
        const { code, data } = res || {}
        if (code === 1 && data.pass === false) {
          this.completeDialogTitle += `<br>${data.failMsg}`
        }
      }
      this.oShow.complete = true
      this.completeId = id
    },

    // 完成事件
    submitCompleteHandle() {
      this.oLoading.state = true
      updateCollectionState({
        id: this.completeId,
        receivableState: 2,
      })
        .then(({ code }) => {
          this.oLoading.state = false
          if (code === 1) {
            this.$message.success('操作成功')
            this.oShow.complete = false
            this.getReceivableList()
          }
        })
        .catch(() => {
          this.oLoading.state = false
        })
    },

    // 展示支付宝支付定时配置弹窗
    async alipayConfig() {
      const res = await checkConfigState({
        type: 30,
      })
      if (res.code === 1 && !res.data) {
        this.msgDialogVisible = true
        this.msgType = 30
        return
      }
      // 查询支付宝定时支付配置是否开通
      const { code, data } = await getAlipayConfig({})
      // 默认状态关闭，时间23:00
      const { state = 0, withholdTime = '23:00:00' } = data
      if (code === 1) {
        this.alipayConfigData = { state, withholdTime }
        this.oShow.alipayConfig = true
      }
    },

    // 展示支付宝支付收款弹窗
    // eslint-disable-next-line vue/no-unused-properties
    async alipayWithhold(row) {
      const res = await checkConfigState({
        type: 30,
      })
      if (res.code === 1 && !res.data) {
        this.msgDialogVisible = true
        this.msgType = 30
        return
      }
      this.receivableItem = row
      this.oShow.alipayWithhold = true
    },
    // 剩余应收金额
    curReceivablAmount(row) {
      const { receivableAmount, receivedAmount, receivingAmount } = row
      return (
        Number(receivableAmount) -
          Number(receivedAmount) -
          Number(receivingAmount) >
        0
      )
    },
    // 搜索条件保存到sessionStorage
    saveSearchData() {
      const params = {
        ...this.getSearchParamrs(),
        pageNum: this.m_paginationData.pageNum,
        pageSize: this.m_paginationData.pageSize,
      }
      sessionStorage.setItem('finance_collection_search_params', JSON.stringify(params))
    },
    initSearchData() {
      const searchDataString = sessionStorage.getItem('finance_collection_search_params')
      if (searchDataString) {
        try {
          const searchData = JSON.parse(searchDataString)
          this.m_paginationData.pageNum = searchData.pageNum
          this.m_paginationData.pageSize = searchData.pageSize
        } catch (e) {
          console.log(e)
        }
      } else {
        this.m_paginationData.pageNum = 1
        this.m_paginationData.pageSize = 10
      }
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.initSearchData()
  },
  activated() {
    this.initSearchData()
  },
}
</script>
